import React, { Component } from "react";
import InputPhoto from "./InputPhoto";
import "./PhotoFieldWithPreview.css";
import AddPhotoIcon from "@material-ui/icons/AddPhotoAlternate";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import PreviewImage from "./PreviewImage";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import ZoomIcon from "@material-ui/icons/ZoomOutMap";
import { getCurrentFunctionName } from "../../performanceModeManager";
import withAuth from "../../components/withAuth";
import { compose } from "redux";
import { connect } from "react-redux";
import { uploadImage } from "../../redux/image/imageActions";
import PropTypes from "prop-types";

class PhotoFieldWithPreview extends Component {
	state = {
		previewImage: false,
		changeImage: false,
	};

	constructor(props) {
		super(props);

		this.inputImage = React.createRef();
	}

	onPhotoClick() {
		this.setState({ previewImage: true });
	}

	onAddPhoto() {
		if (this.props.disabled) return;

		this.inputImage.click();
	}

	deletePhoto() {
		if (this.props.disabled) return;

		let value = "";

		this.setState({
			previewImage: false,
		});

		this.props.onPhotoChange(value);
	}

	closePhotoPreview() {
		this.setState({
			previewImage: false,
		});
	}

	closePhotoImportation(image) {
		this.setState({
			previewImage: image ? true : false,
		});

		this.props.onPhotoChange(image);
	}

	importImage(image) {
		this.props.uploadImage(image);
		this.closePhotoImportation(image);
	}

	handleRef = (r) => {
		this.inputImage = r;
	};

	render() {
		console.perfLog(getCurrentFunctionName());
		return (
			<div className="full_size control-margin-top">
				<InputPhoto
					handleRef={this.handleRef.bind(this)}
					importImage={this.importImage.bind(this)}
					acceptPdfAsImage={this.props.acceptPdfAsImage}
				/>
				{this.state.previewImage ? (
					<PreviewImage
						close={this.closePhotoPreview.bind(this)}
						delete={this.deletePhoto.bind(this)}
						image={this.props.value}
						disabled={this.props.disabled}
					/>
				) : null}
				<GridListTile
					key={this.props.id}
					className="photo-grid-tile"
					disabled={this.props.disabled}
				>
					{this.props.value ? (
						<div
							className="photo-auto-size"
							onClick={this.onPhotoClick.bind(this)}
						>
							<img
								{...this.props.inputProperties}
								src={this.props.value}
								alt="Aperçu"
								className="minify-photo"
							/>
							<ZoomIcon className="photo-center-icon white-icon" />
						</div>
					) : (
						<AddPhotoIcon
							onClick={this.onAddPhoto.bind(this)}
							className="photo-full-size-icon"
							disabled={this.props.disabled}
						/>
					)}
					<GridListTileBar
						title={this.props.label}
						actionIcon={
							this.props.value && !this.props.disabled ? (
								<IconButton onClick={this.deletePhoto.bind(this)}>
									<DeleteIcon className="red-icon" />
								</IconButton>
							) : null
						}
					/>
				</GridListTile>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		image: state.image.image,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		uploadImage: (image) => dispatch(uploadImage(image)),
	};
};

export default compose(
	withAuth,
	connect(mapStateToProps, mapDispatchToProps)
)(PhotoFieldWithPreview);

PhotoFieldWithPreview.propTypes = {
	value: PropTypes.string.isRequired,
	onPhotoChange: PropTypes.func.isRequired,
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
	inputProperties: PropTypes.object,
	acceptPdfAsImage: PropTypes.bool,
};
